import React from 'react';
import { escape } from 'lib/StringEscaping';
import Dropzone from 'react-dropzone'
import Icon from 'components/Icon/Icon.react';
import styles from './FileUpload.scss';

export default class FileUpload extends React.Component {
  constructor() {
    super();
    this.state = {
      files: false,
    };
  }

  onDrop(files) {
    this.setState({
      files: files[0]
    });
    this.props.onChange(files[0]);
  }

  render() {
    return (
      <Dropzone ref="dropzone" onDrop={this.onDrop.bind(this)} accept={this.props.accept} className={styles.dropzone} activeClassName={styles.dropzoneActive}>
        <div className={[styles.appIconHolder, this.state.files[0] ? styles.uploaded : null].join(' ')}>
          <span>Upload a file</span>
        </div>
      </Dropzone>
    );
  }
}
